import { MCCustomFunctionsParams, MCSectionSchema } from "@maslul/common-services";
import { EventsCallBackService } from "../../services/fields/events-callback";


export class MICustomFunctionsParams extends MCCustomFunctionsParams {

    //סכימה כפי שנשלף מהמונגו
    sectionsSchema: Array<MCSectionSchema> = new Array<MCSectionSchema>();;
    sectionSchema: MCSectionSchema = new MCSectionSchema();

    //repeat
    isInRepeat: boolean = false;
    //index for repeat fields
    eventsCallBackService = EventsCallBackService;

}